<h2 class="chart-title" *ngIf(chartTitle.length>0)>{{ chartTitle }}</h2>
<htc-lexical-table
  [editable]="false"
  [fitToParentElement]="fitToParentElement"></htc-lexical-table>
